import { useEffect, useState } from 'react';
import type { RigVehicles } from '../../reference-data/features/tyre-layouts/public/RigShowcase';
import { getFleetPlates } from '../login.api';
import { rigVehicles } from '../policies/rig-vehicles.policy';

/** The fleet vehicles the login panel's rigs show, plate and paint: null while the fleet is asked, none if it can't answer, so the panel still shows. */
export function useRigVehicles(): RigVehicles[] | null {
  const [vehicles, setVehicles] = useState<RigVehicles[] | null>(null);
  useEffect(() => {
    let isCurrent = true;
    getFleetPlates()
      .then(rigVehicles)
      .catch(() => [])
      .then((paired) => {
        if (isCurrent) setVehicles(paired);
      });
    return () => {
      isCurrent = false;
    };
  }, []);
  return vehicles;
}
